import { render, staticRenderFns } from "./EditContract.vue?vue&type=template&id=81adfe8e&scoped=true"
import script from "./EditContract.vue?vue&type=script&lang=ts"
export * from "./EditContract.vue?vue&type=script&lang=ts"
import style0 from "./EditContract.vue?vue&type=style&index=0&id=81adfe8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81adfe8e",
  null
  
)

export default component.exports